<div class="content-card">
  @if (isDelegationAccepted() || isDelegationCorrection()) {
  <h2 class="content-card__header">{{ 'DCF-InitialDelegationCosts' | translate }}</h2>
  }
  <app-delegation-cost-basic-info
    [delegationBasicInfoFormGroup]="delegationBasicInfoFormGroup"
    [delegationCorrectionComment]="delegationSettlement?.Comment"
  ></app-delegation-cost-basic-info>

  @if (isDelegationAccepted() || isDelegationCorrection()) {
  <div class="content-card">
    <h2 class="content-card__header">{{ 'DCF-DelegationData' | translate }}</h2>
    <p>{{ 'DCF-DelegationDataDescription' | translate }}</p>
    <form [formGroup]="delegationBasicInfoFormGroup">
      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'TSG-StartDate' | translate }}</mat-label>
            <input matInput id="delegation-cost-step-start-date-input" [matDatepicker]="startDatePicker" formControlName="pickerStartDate" [matDatepickerFilter]="startDateFilter" />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-12 col-lg-3">
          <ngx-timepicker-field
            id="delegation-cost-step-start-time-picker"
            class="delegation-timepicker"
            [defaultTime]="startTime"
            formControlName="pickerStartTime"
            [format]="timepickerTimeFormat"
            [cancelBtnTmpl]="customCancelButton"
            [confirmBtnTmpl]="customConfirmButton"
          ></ngx-timepicker-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'TSG-EndDate' | translate }}</mat-label>
            <input id="delegation-cost-step-end-date-input" matInput [matDatepicker]="endDatePicker" formControlName="pickerEndDate" [matDatepickerFilter]="endDateFilter" />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
          @if (delegationBasicInfoFormGroup.hasError('dateValid')) {
          <mat-error class="delegation-duration-error">
            {{ 'DCF-InvalidDateRange' | translate }}
          </mat-error>
          }
        </div>
        <div class="col-12 col-lg-3">
          <ngx-timepicker-field
            id="delegation-cost-step-end-time-picker"
            class="delegation-timepicker"
            [defaultTime]="endTime"
            formControlName="pickerEndTime"
            [format]="timepickerTimeFormat"
            [cancelBtnTmpl]="customCancelButton"
            [confirmBtnTmpl]="customConfirmButton"
          ></ngx-timepicker-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button mat-raised-button color="primary" id="delegation-cost-step-save-dates-button" (click)="saveDatesManually()" [disabled]="!isDateChanged || (delegationBasicInfoFormGroup.invalid && !isFormValidExcludingUnsavedDates())">
            {{ 'Save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
  }

  <div class="header-wrapper"></div>

  <div class="content-card">
    <h2 class="content-card__header">{{ 'DCF-DelegationCosts' | translate }}</h2>
    <p>{{ 'DCF-DelegationCostsDescription' | translate }}</p>
    @if (canEdit) {
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-raised-button color="primary" id="delegation-cost-step-open-modal-button" (click)="openCostModal()">{{ 'DCF-AddCost' | translate }}</button>
    </div>
    }
  </div>

  <app-delegation-invoice-list [delegationId]="delegationId" [canEdit]="canEdit"></app-delegation-invoice-list>

  <div class="header-wrapper"></div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-raised-button color="primary" id="delegation-cost-step-next-step-button" (click)="goForward()" [disabled]="delegationBasicInfoFormGroup.invalid && !isFormValidExcludingUnsavedDates()">{{ 'Next' | translate }}</button>
  </div>
</div>

<ng-template #customCancelButton>
  <button mat-button>
    {{ 'Cancel' | translate }}
  </button>
</ng-template>

<ng-template #customConfirmButton>
  <button mat-button>
    {{ 'Yes' | translate }}
  </button>
</ng-template>
